import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrmAuthGuard } from 'common-module/auth';
import { AppRoutes } from '@app/app.routes';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: AppRoutes.portfolio,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('common-module/auth').then((m) => m.CrmAuthModule),
  },
  {
    path: AppRoutes.portfolio,
    canActivate: [CrmAuthGuard],
    loadChildren: () =>
      import('./pages/portfolio/portfolio.module').then(
        (m) => m.PortfolioModule,
      ),
  },
  {
    path: AppRoutes.plcards,
    canActivate: [CrmAuthGuard],
    loadChildren: () =>
      import('@app/pages/pl-cards/pl-card.module').then((m) => m.PlCardModule),
  },
  {
    path: 'envelopes',
    canActivate: [CrmAuthGuard],
    loadChildren: () =>
      import('@app/pages/pl-cards/pl-card.module').then((m) => m.PlCardModule),
  },
  {
    path: AppRoutes.pricelist,
    canActivate: [CrmAuthGuard],
    loadChildren: () =>
      import('./pages/pricelist/pricelist.module').then(
        (m) => m.PricelistModule,
      ),
  },
  {
    path: AppRoutes.offers,
    canActivate: [CrmAuthGuard],
    loadChildren: () =>
      import('./pages/commercial-offer/commercial-offer.module').then(
        (m) => m.CommercialOfferModule,
      ),
  },
  {
    path: AppRoutes.catalogue,
    canActivate: [CrmAuthGuard],
    loadChildren: () =>
      import('./pages/commercial-catalogue/commercial-catalogue.module').then(
        (m) => m.CommercialCatalogueModule,
      ),
  },
  {
    path: AppRoutes.imports,
    canActivate: [CrmAuthGuard],
    loadChildren: () =>
      import('./pages/imports/imports.module').then((m) => m.ImportsModule),
  },
  {
    path: AppRoutes.changelog,
    canActivate: [CrmAuthGuard],
    loadChildren: () =>
      import('./pages/changelog/changelog.module').then(
        (m) => m.ChangelogModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
